'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _markLastMessageReadByVisitor = require('../actions/markLastMessageReadByVisitor');

var _getIsOpen = require('../../selectors/getIsOpen');

var _clearUnseenCountForChannel = require('../../actions/ConversationsActions/clearUnseenCountForChannel');

var _isActiveOnThread = require('../../selectors/clientSelectors/isActiveOnThread');

var _sentByVisitorClient = require('../../pubnub-message/operators/sentByVisitorClient');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _getThreadByThreadId = require('../../threads/selectors/getThreadByThreadId');

var _selectedThreadActionTypes = require('../../selected-thread/constants/selectedThreadActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var markLastMessageRead = function markLastMessageRead(_ref) {
  var store = _ref.store,
      conversation = _ref.conversation,
      messageTimestamp = _ref.messageTimestamp;

  store.dispatch((0, _markLastMessageReadByVisitor.markLastMessageReadByVisitor)({ conversation: conversation, messageTimestamp: messageTimestamp }));
};

var VisitorLastSeenMiddleware = function VisitorLastSeenMiddleware(store) {
  return function (next) {
    return function (action) {
      var state = store.getState();
      var selectedThreadId = (0, _getSelectedThreadId.getSelectedThreadId)(state);

      var widgetIsOpen = (0, _getIsOpen.getIsOpen)(state);

      if (action.type === _selectedThreadActionTypes.SELECT_THREAD) {
        var threadId = action.payload.threadId;


        var _conversation = (0, _getThreadByThreadId.getThreadByThreadId)(state, { threadId: threadId });
        var channel = (0, _threadGetters.getChannel)(_conversation);

        if (!!threadId && !!_conversation) {
          var prevThreadId = (0, _getSelectedThreadId.getSelectedThreadId)(state);

          if (prevThreadId !== _stubbedThreadId.STUBBED_THREAD_ID && threadId !== _stubbedThreadId.STUBBED_THREAD_ID && prevThreadId !== threadId && widgetIsOpen) {
            markLastMessageRead({ store: store, conversation: _conversation });
            store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ channel: channel, threadId: threadId }));
          }
        }
      }

      if (action.type === ActionTypes.RECEIVED_INCOMING_MESSAGE) {
        var currentState = store.getState();
        var _action$payload = action.payload,
            _channel = _action$payload.channel,
            message = _action$payload.message,
            _threadId = _action$payload.threadId;


        if (_channel && (0, _messageTypeComparators.isConversationalMessage)(message) && !(0, _sentByVisitorClient.sentByVisitorClient)(message) && (0, _isActiveOnThread.isActiveOnThread)(currentState, _threadId)) {
          var _conversation2 = (0, _getThreadByThreadId.getThreadByThreadId)(state, { threadId: _threadId });
          var messageTimestamp = (0, _commonMessageFormatGetters.getTimestamp)(message);
          markLastMessageRead({ store: store, conversation: _conversation2, messageTimestamp: messageTimestamp });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ threadId: _threadId }));
        }
      }

      var conversation = (0, _getThreadByThreadId.getThreadByThreadId)(state, {
        threadId: selectedThreadId
      });

      if (action.type === ActionTypes.APP_IN_FOREGROUND) {
        if (widgetIsOpen && conversation) {
          markLastMessageRead({ store: store, conversation: conversation });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ threadId: selectedThreadId }));
        }
      }

      if (action.type === ActionTypes.TOGGLE_OPEN) {
        var _ref2 = action.payload || {},
            widgetWillOpen = _ref2.isOpened;

        if (widgetWillOpen && conversation) {
          markLastMessageRead({ store: store, conversation: conversation });
          store.dispatch((0, _clearUnseenCountForChannel.clearUnseenCountForChannel)({ threadId: selectedThreadId }));
        }
      }

      return next(action);
    };
  };
};
exports.default = VisitorLastSeenMiddleware;
module.exports = exports['default'];